import * as React from 'react'
import { Select } from '@doordash/component-fields'
import { arrayToOptions } from '../../../utilities/vehicle'
import { OnboardingComponentProps } from '.'
import { get } from 'lodash'

export const SelectComponent: React.FC<OnboardingComponentProps> = ({
  conditional_data_map,
  templateResponseData,
  target,
  placeholder,
  ...props
}) => {
  const dependencyTarget = get(templateResponseData, target, '') as string
  if (dependencyTarget && conditional_data_map[dependencyTarget]) {
    return (
      <Select
        options={arrayToOptions(conditional_data_map[dependencyTarget])}
        disabledValue={placeholder}
        {...props}
      />
    )
  }
  const optionsFromTemplate = props.data_map || arrayToOptions(props.data)

  return (
    <Select
      options={optionsFromTemplate}
      disabledValue={placeholder}
      {...props}
    />
  )
}
